import { render, staticRenderFns } from "./ErrorNetwork.vue?vue&type=template&id=24b91ca4"
import script from "./ErrorNetwork.vue?vue&type=script&lang=js"
export * from "./ErrorNetwork.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports